import React, { useEffect } from "react";
import MetaTags from "@components/shared/metaTags";
import { GetStaticPropsContext } from "next";
import { useQuery } from "@tanstack/react-query";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import { GQLDomains, GQLPosts } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
import initialCall from "@helpers/initial-call";
import { activePageAtom } from "@store/generalStore";
import { useSetAtom } from "jotai";
import HeroSection from "@components/news/HeroSection";
import NewsByTags from "@components/news/NewsByTags";
import TrendingNews from "@components/news/TrendingNews";
import InCaseYouMissedIt from "@components/news/InCaseYouMissedIt";

const News = () => {
    const setActivePage = useSetAtom(activePageAtom);
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { data: featuredNews } = useQuery<GQLPosts[]>(["featuredNews"]);

    useEffect(() => {
        setActivePage("news");
    }, []);

    return (
        <>
            <MetaTags
                title={`${translate(
                    translations,
                    "several_newsPage_meta_title",
                )} | Several.com`}
                description={translate(
                    translations,
                    "several_newsPage_meta_description",
                )}
                url={"/news"}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />
            <section className="max-w-7xl mx-auto px-5">
                <HeroSection news={featuredNews} />
                <NewsByTags />
                <TrendingNews />
                <InCaseYouMissedIt />
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("News", ctx);
};
export default News;
